import { render, staticRenderFns } from "./EvaluationQuestionCreateNew.vue?vue&type=template&id=77a409ab&scoped=true&"
import script from "./EvaluationQuestionCreateNew.vue?vue&type=script&lang=js&"
export * from "./EvaluationQuestionCreateNew.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationQuestionCreateNew.vue?vue&type=style&index=0&id=77a409ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a409ab",
  null
  
)

export default component.exports